/* eslint-disable */
import React from 'react';
import { Row, Col, Container } from 'reactstrap';

const CallToAction = () => {
    return (
        <div>
            <div className="spacer feature42 bg-danger-gradiant">
                <Container>
                    <Row className="justify-content-center wrap-feature49-box">
                        <Col lg="7" md="10" className="text-center">
                            <h2 className="title text-white">Warning!</h2>
                            <h6 className="subtitle text-white op-7 m-b-20">This project is still in alpha development stage so bugs and crashes are to be expected. If you find any bug and crash please report.</h6>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default CallToAction;
